export const isCN = () => navigator.language.startsWith('zh');